<template>
    <div class="yesnoquestion-wrapper">
        <ValidationProvider :rules="rules" v-slot="v">
            <div class="yesnoquestion-external flex">
                <div class="flex-1" v-if="label || v.errors.length">
                    <label class="label" v-if="label" v-html="label"></label>
                    <p v-if="v.errors.length" class="!opacity-100 subtext text-error">{{ v.errors[0] }}</p>
                </div>
                <div v-if="hint">
                    <HintComponent :hint="hint" />
                </div>
            </div>
            <div class="yesnoquestion-container flex">
                <div class="btn-wf">
                    <div class="btn-wf-internal" :class="{active: isChecked }" @click="isChecked = true">Yes</div>
                    <div class="btn-wf-internal" :class="{active: !isChecked }" @click="isChecked = false">No</div>
                </div>
            </div>
            <div class="yesnoquestion-checkbox">
                <input v-model="isChecked" :id="id" :checked="isChecked" :name="name" value="true" type="checkbox" />
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import HintComponent from "@components/misc/HintComponent";

export default {
    name: "YesNoQuestionComponent",
    props: {
        name: { type: String, default: "" }, // "Name" prop for naming the input
        id: { type: String, default: "" }, // "id" prop for naming the input
        label: { type: String, default: "" }, // Label used for the input
        hint: { type: String, default: "" }, // For the little "?" that appears with a hint for the specific input field
        rules: { type: String, default: "required"}, // The validation rules set on the input. See VeeValidate for available rules
        value: { default: false }, // true = yes as default - false = no as default
    },
    components: {
        ValidationProvider,
        HintComponent
    },
    computed: {},
    data: function () {
        return {
            isChecked: this.value
        };
    },
    methods: {
    },
    watch: {
		isChecked(value) {
			this.isChecked = !!value;
			this.$emit('input', this.isChecked);
            this.$emit('change', this.isChecked);
		},
        value(value) { // Used to detect hydration
			this.isChecked = !!value;
		}
	}
};
</script>
